module.exports = __webpack_public_path__ + "_/skins/TopazAmp1-2-11f6cf0624da77b1bbe1d48aaef470c2.wsz";